// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yshU","toggleWrap":"styles_toggleWrap__18t1F","content":"styles_content__3Cyov","selectAreaCode":"styles_selectAreaCode__3JLMv"};